import React, { useId } from 'react';
import AiFluidMark from '../../common/chat/shared/AiFluidMark';
import { formatDateTimeJST } from '../../../utils/datetime';

type ArtistAnalysisMeta = {
  ai_analysis_completed?: boolean | null;
  ai_analysis_last_successful_at?: string | null;
};

type Props = {
  artist?: ArtistAnalysisMeta | null;
};

export default function ArtistAiAnalysisBadge({ artist }: Props) {
  const tooltipId = useId();
  if (!artist?.ai_analysis_completed) return null;

  const rawCompletedAt = artist.ai_analysis_last_successful_at || '';
  const completedAt = formatDateTimeJST(rawCompletedAt);
  const accessibleLabel = completedAt
    ? `AI分析済み・最終分析 ${completedAt}`
    : 'AI分析済み';

  return (
    <span
      className="artist-ai-analysis-badge"
      aria-label={accessibleLabel}
      aria-describedby={tooltipId}
      tabIndex={0}
    >
      <AiFluidMark variant="static" className="artist-ai-analysis-badge__mark" />
      <span id={tooltipId} className="artist-ai-analysis-badge__tooltip" role="tooltip">
        <strong>AI分析済み</strong>
        {completedAt ? (
          <time dateTime={rawCompletedAt}>最終分析 {completedAt}</time>
        ) : null}
      </span>
    </span>
  );
}
